import { ThemeProvider, Box, Container, Typography } from "@mui/material";
import { createBookingTheme } from "@/lib/theme";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const BRAND_COLOR = "#7C3AED"; // katanaPurple

// Shown when the booking site is visited without a `?pharmacyId=` link,
// e.g. someone navigates to the bare root directly. Real booking links
// always carry `?pharmacyId=<id>` and are handled by BookingPage instead.
export default function DefaultLandingPage() {
  const theme = createBookingTheme(BRAND_COLOR);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", bgcolor: "grey.50" }}>
        <Box
          sx={{ color: "white", px: 3, py: 4 }}
          style={{ background: `linear-gradient(135deg, ${BRAND_COLOR} 0%, ${BRAND_COLOR}cc 100%)` }}
        >
          <Container maxWidth="md">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              CCS Pharmacy Booking
            </Typography>
            <Typography sx={{ opacity: 0.8, mt: 0.5 }}>
              Book a consultation with your local pharmacy
            </Typography>
          </Container>
        </Box>

        <Container maxWidth="md" sx={{ py: 8 }}>
          <Box sx={{ textAlign: "center" }}>
            <CalendarMonthIcon sx={{ fontSize: 48, color: "text.disabled", mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              No pharmacy selected
            </Typography>
            <Typography color="text.secondary" sx={{ maxWidth: 480, mx: "auto" }}>
              This page is used to book a consultation at a specific CCS pharmacy. Please use the
              booking link provided by your pharmacy, or ask them for one.
            </Typography>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
